export const DEFAULT_PAGE_SIZE = 50;

export function currentPageReportTemplate(params: { currentPage: number, total: number, pageTotal: number, isFiltered?: boolean, module?: string }): string {

    const { total, pageTotal, isFiltered, currentPage, module } = params

    if (total === 0 && pageTotal === 0)
        return 'No results found';

    const filterApplied = isFiltered ? ' - Filter Applied' : '';
    return `Page ${currentPage} of ${pageTotal} (${total} ${module}${filterApplied})`;
}